import { createFileRoute } from '@tanstack/react-router';

import { TeacherDashboard } from '@/features/dashboard/TeacherDashboard';

export const Route = createFileRoute('/_authenticated/teacher-dashboard/')({
  component: TeacherDashboard,
});
